// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2wkm6","content":"Consent_content__14HVP","footer":"Consent_footer__MAaPj"};